<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Sale Confirmation</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-grid>
    <ion-row>
      <ion-col size="0" size-sm="1" size-md="2" size-lg="3" size-xl="4"></ion-col>
      <ion-col size="12" size-sm="10" size-md="8" size-lg="6" size-xl="4">
        <ng-container *ngIf="sale">
          <form [formGroup]="emailForm" *ngIf="completed">
            <ion-list>
              <ion-list-header>
                <h6>Send a digital receipt to:</h6>
              </ion-list-header>
      
              <ion-item-group>
                <ion-item class="ion-no-margin" lines="none">
                  <ion-checkbox
                    formControlName="clientEmailCheckBox"
                    slot="start"
                    checked="true"
                  ></ion-checkbox>
                  <ion-label>
                    <ion-icon name="mail"></ion-icon>
                  </ion-label>
                  <ion-input
                    type="email"
                    name="email"
                    placeholder="Enter an email"
                    formControlName="email"
                    clearInput
                  ></ion-input>
                </ion-item>
      
                <ion-item
                  [hidden]="emailField.valid || (emailField.pristine && !submitted)"
                  lines="none"
                >
                  <p
                    *ngIf="emailField.hasError('required') || emailField.hasError('validateEmail')"
                    class="smr-error"
                  >
                    Oops, that email is invalid.
                  </p>
                </ion-item>
      
                <ion-item class="ion-no-margin" lines="none">
                  <ion-checkbox
                    formControlName="clientPhoneCheckBox"
                    slot="start"
                  ></ion-checkbox>
                  <ion-label>
                    <ion-icon name="chatbox-ellipses"></ion-icon>
                  </ion-label>
                  <ion-input
                    type="text"
                    name="phone"
                    placeholder=""
                    formControlName="phone"
                    clearInput
                  ></ion-input>
                </ion-item>
      
                <ion-item
                  [hidden]="phoneField.valid || (phoneField.pristine && !submitted)"
                  lines="none"
                >
                  <p
                    *ngIf="phoneField.hasError('required') || phoneField.hasError('validatePhone')"
                    class="smr-error"
                  >
                    Oops, that phone is invalid.
                  </p>
                </ion-item>
              </ion-item-group>
            </ion-list>
          </form>
        </ng-container>
        <smr-sale-details [sale]="sale" [isConfirmationPage]="true"></smr-sale-details>
      </ion-col>
      <ion-col size="0" size-sm="1" size-md="2" size-lg="3" size-xl="4"></ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-no-margin">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button
          expand="block"
          fill="outline"
          color="primary"
          class="ion-no-margin"
          [disabled]="!completed"
          (click)="close()"
        >
          No Thanks
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button
          expand="block"
          color="primary"
          class="ion-no-margin"
          fill="outline"
          [disabled]="!completed"
          (click)="printReceipt()"
        >
          Print
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button
          expand="block"
          color="primary"
          class="ion-no-margin"
          [disabled]="!completed || !emailForm.valid"
          (click)="sendReceipt()"
        >
          Send Receipt
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
